/*
  Mini-cart drawer interactions: open/close + remove item.
  Add this as its own snippet/asset, e.g. assets/mini-cart-interactions.js,
  and load it with:
    <script src="{{ 'mini-cart-interactions.js' | asset_url }}" defer></script>
  in theme.liquid (once, near the bottom, after jQuery has loaded).

  Uses event delegation on document so it keeps working even after
  refreshCartDrawer() replaces #slidedown-cart's innerHTML.
*/
(function () {

    function openDrawer() {
        document.body.classList.add("cart_toggle");

        const cart = document.getElementById("slidedown-cart");
        if (cart) {
            cart.classList.add("active");
        }
    }

    function closeDrawer() {
        document.body.classList.remove("cart_toggle");

        const cart = document.getElementById("slidedown-cart");
        if (cart) {
            cart.classList.remove("active");
        }
    }

    document.addEventListener("click", function(e){

        const close=e.target.closest(".cart-close");

        if(close){
            e.preventDefault();
            e.stopImmediatePropagation();
            closeDrawer();
            return;
        }

        if(e.target.classList.contains("overlay")){
            closeDrawer();
            return;
        }

        const remove=e.target.closest(".btn-remove");

        if(remove){

            e.preventDefault();
            e.stopImmediatePropagation();

            const item=remove.closest("li.item");

            if(!item) return;

            const variant=item.id.replace("cart-item-","");

            fetch("/cart/change.js",{
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify({
                    id:variant,
                    quantity:0
                })
            })
            .then(function(){
                location.reload();
            });

        }

    },true);

    document.addEventListener("keydown",function(e){
        if(e.key==="Escape"){
            closeDrawer();
        }
    });

})();